export const menu = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.navigation.shadow}",
    transitionDuration: "{transition.duration}",
  },
  list: {
    padding: "{navigation.list.padding}",
    gap: "{navigation.list.gap}",
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    padding: "{navigation.item.padding}",
    borderRadius: "{navigation.item.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
    },
  },
  submenuLabel: {
    padding: "{navigation.submenu.label.padding}",
    fontWeight: "{navigation.submenu.label.font.weight}",
    background: "{navigation.submenu.label.background}",
    color: "{navigation.submenu.label.color}",
  },
  separator: {
    borderColor: "{content.border.color}",
  },
  ui: {
    item: {
      fontLeading: "{content.font.leading}",
    },
  },
  colorScheme: {
    light: {
      danger: "{danger.default}",
    },
    dark: {
      danger: "{danger.support}",
    },
  },
  css: ({ dt }: any): string => `
    .p-menu.p-menu-overlay {
      max-height: 50vh;
      overflow-y: auto;
    }

    .p-menu-item-label {
      line-height: ${dt("menu.ui.item.font.leading")};
    }

    .p-menu-item-danger .p-menu-item-content,
    .p-menu-item-danger .p-menu-item-icon {
      color: ${dt("menu.danger")};
    }

    .p-menu-item-link {
      font-weight: inherit;
    }
  `,
};
